export interface AddTask {
  task_title: string;
  task_type_id: string;
  client_id: string;
  project_id: string;
  communication_received_from: string;
  communication_send_to: string;
  email_subject: string;
  communication_date: Date | string;
  communicationhours: string;
  communicationmins: string;
  task_start_date: Date | string;
  task_end_date: Date | string;
  task_hours: string;
  task_mins: string;
  task_status: string;
  task_priority: string;
  task_alert_require: string;
  addTeamCheck: boolean;
  taskuser_ids: string;
  task_comments: string;
  task_id?: string;
}

export interface TaskList {
  taskDetail: TaskDetail[];
  task_id: string;
}

/** Counts block returned inside data.counts */
export interface TaskListCounts {
  total_tasks: string;
  active_tasks: string;
  inprogress_tasks: string;
  completed_tasks: string;
  overdue_tasks: string;
}

/** Wrapper for the new task list API shape: { counts, data } */
export interface TaskListApiData {
  counts: TaskListCounts;
  data: TaskList[];
}

export interface TaskDetail {
  category_name: string;
  client_id: string;
  client_name: string;
  closedBy: string;
  closedby_first_name: string;
  closedby_last_name: string;
  communication_date: Date | string;
  communication_hourmin: string;
  communication_received_from: string;
  communication_send_to: string;
  contactName: string;
  createdBy: string;
  createdOn: Date | string;
  createdby_first_name: string;
  createdby_last_name: string;
  email_subject: string;
  id: string;
  project_id: string;
  task_alert_require: string;
  task_comments: string;
  task_end_date: Date | string;
  task_hours: string;
  task_priority: string;
  task_start_date: string | Date;
  task_status: string;
  task_title: string;
  task_type_id: string;
  task_uniqueid: string;
  tasksentfrom_first_name: string;
  tasksentfrom_last_name: string;
  tasksento_last_name: string;
  tasksentto_first_name: string;
  status: string;
  company_name: string;
  project_name: string;
  project_shortname: string;
  userinfo: TaskUserDetail[];
  assignee_array: string[];
  active_status?: string;
  last_comment?: string;
  last_comment_date?: string;
}

export interface TaskUserDetail {
  first_name: string;
  last_name: string;
  full_name: string;
  users_id: string;
}
